import ImpressionLogger from '@/components/common/ImpressionLogger';
import InfiniteScroll from '@/components/common/infinite-scroll';
import { ORDER_LOG_EVENT } from '@/constants/logs/order';
import { AdditionalOrderProductModel } from '@/entities/additional-order/model/AdditionalOrder';
import { useRouter } from 'next/router';
import AdditionalOrderProductItem from './AdditionalOrderProductItem';
import EmptyAdditionOrderProducts from './EmptyAdditionOrderProducts';

interface Props {
  additionalOrderProducts?: AdditionalOrderProductModel[];
  isLoadingAdditionalOrderProducts: boolean;
  hasNextPageAdditionalOrderProducts: boolean;
  fetchNextPageAdditionalOrderProducts: () => void;
  getIsSelectedProduct: (product: AdditionalOrderProductModel) => boolean;
  getSelectedProductCount: (product: AdditionalOrderProductModel) => number;
  onAddProductToCart: (product: AdditionalOrderProductModel) => void;
  onRemoveProductFromCart: (product: AdditionalOrderProductModel) => void;
}

const AdditionalOrderProducts = (props: Props) => {
  const router = useRouter();
  const { pharmacyId, diagnosisId } = router.query;

  if (!props.additionalOrderProducts) return <></>;
  if (props.additionalOrderProducts.length === 0) return <EmptyAdditionOrderProducts />;

  return (
    <InfiniteScroll
      rootMargin={'0px 0px 0px 100px'}
      isLoading={props.isLoadingAdditionalOrderProducts}
      hasNextPage={props.hasNextPageAdditionalOrderProducts}
      fetchNextPage={props.fetchNextPageAdditionalOrderProducts}
    >
      {props.additionalOrderProducts.map((product, index) => (
        <ImpressionLogger
          key={product.id}
          enabled={true}
          params={{
            eventName: ORDER_LOG_EVENT.IMPRESSED_ADDITIONAL_ORDER_PRODUCT,
            payload: {
              productId: product.id,
              productName: product.name,
              categoryId: product.categoryId,
              price: product.price,
              position: index,
              pharmacyId: String(pharmacyId),
              diagnosisId: String(diagnosisId),
            },
          }}
        >
          <AdditionalOrderProductItem
            product={product}
            isSelected={props.getIsSelectedProduct(product)}
            selectedCount={props.getSelectedProductCount(product)}
            onAddProductToCart={props.onAddProductToCart}
            onRemoveProductFromCart={props.onRemoveProductFromCart}
          />
        </ImpressionLogger>
      ))}
    </InfiniteScroll>
  );
};

export default AdditionalOrderProducts;
